import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = (props: SvgProps) => (
  <Svg viewBox="0 0 256 256" width={16} height={16} {...props}>
    <Path
      fill={props.color ? props.color : '#000'}
      d="M96 216a8.5 8.5 0 0 1-5.7-2.3 8.1 8.1 0 0 1 0-11.4l74.4-74.3-74.4-74.3a8.1 8.1 0 0 1 11.4-11.4l80 80a8.1 8.1 0 0 1 0 11.4l-80 80A8.5 8.5 0 0 1 96 216Z"
    />
  </Svg>
);

const CaretRight = memo(SvgComponent);
export default CaretRight;
